export const contactUsPhone = { value: '0345 0260092', text: '0345 0260092' };
